import React from 'react';
import styled, { css } from 'styled-components';
import { useTranslation } from 'react-i18next';
import { getColor } from '../../core/themev3';
import { selectColor } from '../../core';
import AtencionPrint from '../../assets/img/AtencionPrint.svg';

const PrintModal = ({ onClose, device, handleCTA }) => {
  const { t } = useTranslation();

  return (
    <Container device={device} data-panel='panel-modal-print-container'>
      <Img src={AtencionPrint} data-panel='panel-modal-print-image' />
      <div>
        <h3 data-panel='panel-modal-print-title'>{t('panel.avisos.print.modal.title')}</h3>
        <p data-panel='panel-modal-print-text'>{t('panel.avisos.print.modal.text')}</p>
      </div>
      <CTA
        onClick={() => {
          onClose();
          handleCTA();
        }}
        data-panel='panel-modal-print-buttonCTA'
      >
        {t('panel.avisos.print.modal.CTA')}
      </CTA>
    </Container>
  );
};

const Container = styled.div`
  padding: ${({ device }) => (device === 'mobile' ? '32px 42px' : '28px')};
  box-sizing: border-box;
  height: ${({ device }) => (device === 'mobile' ? 'fit-content' : '100%')};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  h3 {
    font-family: Hind;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 26px;
    letter-spacing: 0em;
    text-align: center;
    white-space: normal;
    margin-bottom: 8px;
  }
  p {
    font-family: Hind;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 26px;
    letter-spacing: 0em;
    text-align: center;
    white-space: normal;
    color: ${selectColor('grayDark')};
    margin-top: 15px;
  }
`;

const Img = styled.div`
  background-image: url(${({ src }) => src});
  width: 257px;
  height: 136.44px;
  margin-top: 28px;
`;

const CTA = styled.button`
  height: 48px;
  width: 100%;
  border-radius: 12px;
  color: white;
  background-color: ${getColor('primary')};
  font-family: Hind;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 21px;
  letter-spacing: 0em;
  text-align: center;
  cursor: pointer;
  ${({ disabled }) =>
    disabled &&
    css`
      background-color: ${selectColor('grayLight')};
      color: ${selectColor('grayMediumLight')};
      cursor: auto;
    `};
`;

export default PrintModal;
